import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConvexProviderWithAuth, ConvexReactClient } from "convex/react";
import App from './App';
import { initSimpleappRuntimeSafely } from './lib/init-runtime';
import { runtimeConfig } from './lib/runtime-config';
import { useConvexAuthFromLogto } from './lib/use-convex-auth';
import './index.css';

initSimpleappRuntimeSafely({
  appId: runtimeConfig.simpleappId,
  appVersion: runtimeConfig.simpleappVersion,
});

const convex = new ConvexReactClient(runtimeConfig.convexUrl, {
  skipConvexDeploymentUrlCheck: true,
  authRefreshTokenLeewaySeconds: 30,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConvexProviderWithAuth client={convex} useAuth={useConvexAuthFromLogto}>
      <App />
    </ConvexProviderWithAuth>
  </React.StrictMode>
);
